import React from 'react';
import {NavLink} from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import {LoginMenu} from "./api-authorization/LoginMenu";
import logo from '../assets/icons/logo.svg'
import file from '../assets/Руководство пользователя SKARB-SOIL 1.1.2025.pdf'

const Sidebar = ({children}) => {
    const menuItem = [
        {
            path: "/fields",
            name: "Поля",
        },
        {
            path: "/directory",
            name: "Справочник",
        },
        {
            path: "/fertilizers",
            name: "Удобрения",
        },
        {
            path: "/calculations",
            name: "Расчет",
        },
        {
            path: "/reports",
            name: "Отчеты",
        }
    ]
    return (
        <div className='container1'>
            <div className="menu">
                <div className='sidebar'>
                    <img src={logo} className='logo-icon' alt="logo"/>
                    <div className="logo">SKARB-SOIL</div>
                    <div className='div-line'></div>
                    <div className='menu-container'>
                        {menuItem.map((item, index) => (
                            <NavLink to={item.path} key={index} className='menu-item' activeClassName='active-item'>
                                <div className='label-menu-item'>{item.name}</div>
                            </NavLink>
                        ))}
                    </div>
                    <div className='manual'><a target="_blank" href={file}>Руководство пользователя</a></div>
                    <LoginMenu></LoginMenu>
                </div>
            </div>
            <main>{children}</main>
        </div>
    )
};

export default Sidebar;